import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';

export type Lang = 'de' | 'en';

interface LanguageContextValue {
  lang: Lang;
  toggleLang: () => void;
  setLang: (l: Lang) => void;
}

const LanguageContext = createContext<LanguageContextValue>({
  lang: 'de',
  toggleLang: () => {},
  setLang: () => {},
});

function langFromLocation(): Lang {
  if (typeof window === 'undefined') return 'de';
  const path = window.location.pathname.replace(/\/+$/, '') || '/';
  return path === '/en' ? 'en' : 'de';
}

export const LanguageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [lang, setLang] = useState<Lang>(langFromLocation);
  const toggleLang = useCallback(() => setLang((l) => (l === 'de' ? 'en' : 'de')), []);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, toggleLang, setLang }}>
      {children}
    </LanguageContext.Provider>
  );
};

export function useLang() {
  return useContext(LanguageContext);
}
